export function rotatingNutSlider() {

    if (window.innerWidth >= 1200) {

        let canvasForIntro = document.getElementById("nut-intro-animation-box");
        let contextForIntro = canvasForIntro.getContext("2d");
        let filesForIntro = canvasForIntro.dataset.directoryUrl;
        let introAnim;
        let introCounter = 0;

        canvasForIntro.width = 1800;
        canvasForIntro.height = 1800;

        let currentFrameForIntro = index => (`${filesForIntro}/${index.toString().padStart(4, "0")}.webp`);
        let frameCountForIntro = 48;
        let imagesForIntro = [];

        let preloadimagesForIntro = () => {
            for (let i = 1; i <= frameCountForIntro; i++) {
                imagesForIntro[i] = new Image();
                imagesForIntro[i].src = currentFrameForIntro(i);
            }
        };
        preloadimagesForIntro();

        let imgForIntro = new Image();
        imgForIntro.src = currentFrameForIntro(1);
        imgForIntro.onload = function () {
            contextForIntro.drawImage(imgForIntro, 0, 0);
        };

        let frameIndexIntro = 1;

        function imageAnimationIntro() {
            if (frameIndexIntro >= frameCountForIntro - 1) {
                clearInterval(introAnim);
                frameIndexIntro = frameCountForIntro - 2;
                document.getElementsByClassName("sliders-container")[0].classList.add("show-sliders");

                // if butter is first slide
                // document.getElementsByClassName("origin-image-wrap")[0].classList.add("has-butter");
                // runButterAnimation();
                
            }

            frameIndexIntro++;
            requestAnimationFrame(() => {
                contextForIntro.clearRect(0, 0, canvasForIntro.width, canvasForIntro.height);
                contextForIntro.drawImage(imagesForIntro[frameIndexIntro + 1], 0, 0);
            });
        }

        function runIntroAnimation() {
            introAnim = setInterval(imageAnimationIntro, 50);
        };

        // -----------------------------------------------------------------------------

        let $parent = $(".rotating-nuts-section");
        let $slidersHolder = $(".sliders-container");
        let $sliderContainer = $parent.find(".home-media-slider");
        let $sliderContainerNav = $parent.find(".home-media-nav");

        $(".media-nav-item").each((index, item) => {
            $("<div class='media-nav-item'><p>"+ $($(item).find("p")[0]).text() +"</p><p class='active-title'>"+ $($(item).find("p")[0]).text()  +"</p></div>").appendTo($sliderContainerNav);
        });
        let currentSlide = 0;
        let navSlide;
        let prevSlide;

        $sliderContainer.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            mobileFirst: true,
            focusOnSelect: true,
            draggable: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            asNavFor: $sliderContainerNav,
        }).on("beforeChange", function (event, slick, direction, nextSlide) {
            if (nextSlide === 10) {
                setTimeout(() => {
                    $($sliderContainer.find(".slick-slide")[0]).addClass("slick-current slick-active");
                }, 100);
            }
        });

        $sliderContainerNav.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 1000,
            asNavFor: $sliderContainer,
            mobileFirst: true,
            centerMode: true,
            variableWidth: true,
            centerPadding: "0px",
            infinite: true,
            draggable: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                        centerPadding: "0px",
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 5,
                        centerMode: true,
                        variableWidth: false,
                    }
                },
            ]
        }).on("beforeChange", function (event, slick, direction, nextSlide) {

            if (currentSlide !== nextSlide) {
                let nextCurSlide;
                navSlide = $sliderContainerNav.find(".slick-current");
                prevSlide = $(".prev-current");

                if (prevSlide.length) {
                    prevSlide.removeClass("prev-current");
                }

                if (currentSlide > nextSlide) { // if fire slider to prev

                    if ((currentSlide - nextSlide) > 1) {
                        nextCurSlide = $sliderContainerNav.find(".slick-active")[0];
                    } else {
                        nextCurSlide = $sliderContainerNav.find(".slick-active")[1];
                    }
                } else {  // if fire slider to next
                    if ((nextSlide - currentSlide) > 1) {
                        nextCurSlide = $sliderContainerNav.find(".slick-active")[4];
                    } else {
                        nextCurSlide = $sliderContainerNav.find(".slick-active")[3];
                    }
                }

                if ($(nextCurSlide).prev().length) {
                    $(nextCurSlide).prev().addClass("prev-current");
                }

                currentSlide = nextSlide;
            }
            if ($slidersHolder.hasClass("show-sliders")) {
                $sliderContainer.addClass("changed-slide");
            }
        }).on("afterChange", function (event, slick, direction, nextSlide) {

            let prevSlideAfterChange = $(".prev-current");

            if (prevSlideAfterChange.length && !prevSlideAfterChange.hasClass("slick-active") || !$sliderContainer.hasClass("changed-slide")) {
                prevSlideAfterChange.removeClass("prev-current");
                $($sliderContainerNav.find(".slick-active")[1]).addClass("prev-current");
            }
        });

        $(window).on("scroll", function () {

            if ($slidersHolder.hasClass("animated") && $(window).width() >= 1200 && introCounter === 0) {
                runIntroAnimation();
                introCounter++;
                setTimeout(() => {
                    $sliderContainerNav.slick("slickGoTo", 0);
                }, 700);
            }
        });
    } else {
        let $parent = $(".rotating-nuts-section");
        let $slidersHolder = $(".sliders-container");
        let $sliderContainer = $parent.find(".home-media-slider");
        let $sliderContainerNav = $parent.find(".home-media-nav");
        let flag = true;

        $sliderContainer.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            focusOnSelect: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            mobileFirst: true,
            asNavFor: $sliderContainerNav,
            draggable: false,
        });

        $sliderContainerNav.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnFocus: false,
            pauseOnHover: false,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            speed: 1000,
            asNavFor: $sliderContainer,
            mobileFirst: true,
            centerMode: true,
            variableWidth: true,
            centerPadding: "0px",
            infinite: true,
            draggable: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                        centerPadding: "0px",
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 5,
                        centerMode: true,
                        variableWidth: false,
                    }
                },
            ]
        });

        $sliderContainer.addClass("changed-slide");

        $(window).on("scroll", function () {

            if ($slidersHolder.hasClass("animated") && flag) {
                flag = false;
                $sliderContainerNav.slick("slickGoTo", 0);
            }
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/rotatingNutSlider.js